import React from "react";
import styles from "./style.module.scss";
import Modal from "../../../../../../../../../../components/modal";
import Button from "../../../../../../../../../../components/new-button";
import useDomainStore from "../../../../../../../../../../stores/domain";

const ConfirmPdfModal = ({
  isOpen,
  onClose,
  consentPdfStatus,
  submitApplication,
}) => {
  const isKurvDomain = useDomainStore((state) => state.isKurvDomain);
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} header="Confirm PDF" size="md">
      <div className={`${styles.body} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        Your agent has requested you to sign {consentPdfStatus.totalPdf}{" "}
        processor application(s), you have chosen to sign only{" "}
        {consentPdfStatus.viewedPdf} application(s), please confirm before
        continuing.
      </div>
      <footer className={styles.footer}>
        <Button
          type="button"
          variant="primary"
          onClick={() => {
            submitApplication();
          }}
        >
          Continue
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
      </footer>
    </Modal>
  );
};

export default ConfirmPdfModal;
